"use client";
import Callary from "./Callary";
import SectionHeading from "../../section-heading";

const Projects = () => {
  return (
    <section id="projects" className="relative py-24 px-4">
      <SectionHeading
        eyebrow="[Projects]"
        title="Selected"
        highlight="work"
        description="Production SaaS, dashboards, and product UIs — from cybersecurity to e-commerce."
      />
      <div className="max-w-7xl mx-auto">
        <Callary />
      </div>
    </section>
  );
};

export default Projects;
